import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import WaitingRoomsPage from '../waiting-rooms/containers/WaitingRoomsPage';
import WaitingRoomPage from '../waiting-rooms/containers/WaitingRoomPage';
import WaitingRoomPreviewPage from '../waiting-rooms/containers/WaitingRoomPreviewPage';
import OAuthCallback from '../waiting-rooms/containers/OAuthCallback';
import NotFound from './components/NotFound';

const router = createBrowserRouter([
    {
        path: '/admin',
        element: <WaitingRoomsPage />,
    },
    {
        path: '/admin/waiting-rooms',
        element: <WaitingRoomsPage />,
    },
    {
        path: '/waiting-room',
        element: <WaitingRoomPage />,
    },
    {
        path: '/waiting-room/preview/:id',
        element: <WaitingRoomPreviewPage />,
    },
    {
        path: '/oauth/callback',
        element: <OAuthCallback />,
    },
    {
        path: '*',
        element: <NotFound />,
    },
]);

export default router;
